module.exports = __webpack_public_path__ + "img/plus.9fa6d149.svg";